export const getIsFooterVisible = (): boolean => {
  const footerEl = document.getElementById("footer-control");
  return (
    !!footerEl && footerEl.offsetHeight > 0 && !footerEl.classList.contains("hide")
  );
};
